/**
 * <best-seller-atc> — Add-to-cart button wrapper for the Best Sellers section.
 *
 * Attributes:
 *   data-variant-id  (required) Shopify variant ID to add
 *
 * Reads window.Cart (cart.js) for the actual API call.
 * Fires no extra events — cart.js handles cart:change / cart:error dispatch.
 */

class BestSellerAtc extends HTMLElement {
  connectedCallback() {
    this._btn = this.querySelector('.lp-index-best-seller__atc');
    if (!this._btn) return;
    this._labelEl = this.querySelector('.lp-index-best-seller__atc-label');
    this._label = this._labelEl?.textContent.trim()
      || this._btn.getAttribute('aria-label')
      || 'Add to cart';
    this._handleClick = this._handleClick.bind(this);
    this._btn.addEventListener('click', this._handleClick);
  }

  disconnectedCallback() {
    this._btn?.removeEventListener('click', this._handleClick);
    clearTimeout(this._errTimer);
  }

  _handleClick() {
    const variantId = this.dataset.variantId;
    if (!variantId || !window.Cart) return;

    const fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');

    this._clearError();
    this._setLoading(true);

    window.Cart.add(fd, this)
      .catch((error) => this._showError(error.description || error.message))
      .finally(() => this._setLoading(false));
  }

  _setLoading(loading) {
    if (!this._btn) return;
    this._btn.disabled = loading;
    this._btn.setAttribute('aria-busy', String(loading));
    if (this._labelEl) {
      this._labelEl.textContent = loading ? 'Adding...' : this._label;
    }
  }

  _clearError() {
    const err = this.querySelector('.lp-index-best-seller__atc-error');
    if (err) err.textContent = '';
    clearTimeout(this._errTimer);
  }

  _showError(message) {
    let err = this.querySelector('.lp-index-best-seller__atc-error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'lp-index-best-seller__atc-error';
      this.appendChild(err);
    }
    err.textContent = message;
    this._errTimer = setTimeout(() => { err.textContent = ''; }, 4000);
  }
}

if (!customElements.get('best-seller-atc')) {
  customElements.define('best-seller-atc', BestSellerAtc);
}
